import { Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import TopBar from '../../../Layout/components/TopBar/TopBar';
import { ProjectsTab } from '../api/models/PojectsTabs';
import ProjectsTabPanels from '../components/ProjectsTabPanels/ProjectsTabPanels';

const ProjectList = () => {
    const { tab } = useParams();
    return (
        <>
            <TopBar>
                <Typography variant='h4'>Projects</Typography>
            </TopBar>

            <ProjectsTabPanels routeTab={(tab || 'my') as ProjectsTab} />
        </>
    );
};

export default ProjectList;
